export default async function putTags(putParams){
    //console.log("key starts with number");
    await fetch('https://nmk8rxiom5.execute-api.us-east-1.amazonaws.com/deploy?operation=Add_tags',{
      method: "POST",
      body: JSON.stringify(putParams)
    })
    .then(response => response.json())
    .then(json => console.log(json))
    .catch(err => console.log(err));
}